import { useIntercomUserQuery } from "../../api/intercom/useIntercomUserQuery";
import { authService } from "../../services/AuthService";
import { intercomService } from "../../services/IntercomService";

export function IntercomMessenger() {
  const authData = authService.getLoginData();

  useIntercomUserQuery({
    payload: {
      wpuId: authData.wpuId,
    },
    options: {
      enabled: !!authData.wpuId,
      onSuccess: (data) => {
        intercomService.boot({
          appId: data?.appId,
          userId: data.id,
          name: `${data.firstname} ${data.lastname}`,
          email: data.email_id,
          createdAt: data.created,
          companyId: data.company_id,
          companyName: data.company_name,
        });
      },
    },
  });

  return null;
}
